export default {
  PERMANENTLY_PRODUCT_ID: 523234,
  PERMANENTLY_SYSTEM_SET_FEE: 3000,
  PERMANENTLY_MONTHLY_PAYMENT: 1990,
  PR_PRODUCT_ID: 523188,
  CONTRACT_TYPE: {
    TRANSFER_PLATFORM: 4,
  },
};
